import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Total Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=9090-23945&m=dev)
 * */
const TotalIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M0.75 11.25H3V6.375C3 6.16789 2.83211 6 2.625 6H1.125C0.917893 6 0.75 6.16789 0.75 6.375V11.25ZM0.75 11.25H11.25M11.25 11.25V4.375C11.25 4.16789 11.0821 4 10.875 4H9.375C9.16789 4 9 4.16789 9 4.375V11.25H11.25ZM7.125 11.25V1.375C7.125 1.16789 6.95711 1 6.75 1H5.25C5.04289 1 4.875 1.16789 4.875 1.375V11.25H7.125Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default TotalIcon;